import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Courses } from "@/components/site/Courses";
import { Gear } from "@/components/site/Gear";
import { Killhouse } from "@/components/site/Killhouse";
import { Workshop } from "@/components/site/Workshop";
import { Partners } from "@/components/site/Partners";
import { Ethos } from "@/components/site/Ethos";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { Gallery } from "@/components/site/Gallery";
import { CustomSection } from "@/components/site/CustomSection";
import { useSite } from "@/lib/site";

const BLOCKS = { courses: Courses, gear: Gear, workshop: Workshop, killhouse: Killhouse, ethos: Ethos, gallery: Gallery, partners: Partners, contact: Contact };

export default function Home() {
  const { config } = useSite();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="grain">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        {config.sections.filter((s) => s.visible).map((s, i) => {
          if (s.custom) return <CustomSection key={s.key} s={s} index={i} />;
          const Block = BLOCKS[s.key];
          return Block ? <Block key={s.key} /> : null;
        })}
      </main>
      <Footer />
    </div>
  );
}
